import { Injectable } from '@angular/core';

/*
  Generated class for the OkageStorageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export class OkageStorageProvider {

  private _values;

  constructor() {
    this._values = {};
  }

  /**
   * localStorage.setItem
   * @param key 
   * @param val 
   */
  setItem(key, val){
    this._values[key] = val;
  }

  /**
   * localStorage.getItem
   * @param key 
   */
  getItem(key){
    return this._values[key];
  }

  /**
   * storage. set
   * 
   * @param key 
   * @param val 
   */
  set(key, val):Promise<any>{
    return new Promise((resolve, reject) => {
      this._values[key] = val;
      resolve();
    });
  }

  /**
   * storage.get 
   * @param key 
   */
  get(key):Promise<any>{
    return new Promise((resolve, reject) => {
      resolve(this._values[key]);
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/okage-storage/okage-storage.ts